import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import GeoLocationComponent, {
  GeoLocation,
} from 'components/GeoLocationComponent/GeoLocationComponent';

interface FormGeoLocationFieldProps {
  name: string;
  label?: string;
  required?: boolean;
  className?: string;
  disabled?: boolean;
  /** Fired after the location value changes (HWCG tip auto-persist). */
  onCommit?: () => void;
}

const FormGeoLocationField: React.FC<FormGeoLocationFieldProps> = ({
  name,
  label = 'Location',
  required = false,
  className = '',
  disabled: _disabled = false,
  onCommit,
}) => {
  const { control } = useFormContext();

  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label className="form-label">
          {label}
          {required && <span className="text-danger"> *</span>}
        </label>
      )}
      <Controller
        name={name}
        control={control}
        rules={{ required: required ? `${label} is required` : false }}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <>
            <GeoLocationComponent
              location={value}
              setLocation={(location: GeoLocation) => {
                onChange(location);
                onCommit?.();
              }}
            />
            {error && (
              <div className="invalid-feedback d-block">{error.message}</div>
            )}
          </>
        )}
      />
    </div>
  );
};

export default FormGeoLocationField;
